import { render } from "./PublicProfile.vue?vue&type=template&id=d223254a&scoped=true"
import script from "./PublicProfile.vue?vue&type=script&lang=js"
export * from "./PublicProfile.vue?vue&type=script&lang=js"

import "./PublicProfile.vue?vue&type=style&index=0&id=d223254a&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d223254a"]])

export default __exports__